import { render, staticRenderFns } from "./LiveList.vue?vue&type=template&id=f3a881b0&scoped=true&"
import script from "./LiveList.vue?vue&type=script&lang=js&"
export * from "./LiveList.vue?vue&type=script&lang=js&"
import style0 from "./LiveList.vue?vue&type=style&index=0&id=f3a881b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a881b0",
  null
  
)

export default component.exports